class AvisoModalServicio {
    subscribers = [];

    subscribe(fn) {
        this.subscribers.push(fn);
        return () => {
            this.subscribers = this.subscribers.filter((s) => s !== fn);
        };
    }


    show(config) {
        this.subscribers.forEach((fn) => fn(config));
    }
    showError(mensaje) {
        this.show({tipo: "error",  titulo: "Error", mensaje: mensaje});
    }
    showAviso(mensaje) {
        this.show({tipo: "warning",  titulo: "Aviso", mensaje: mensaje});
    }

    showInfo(mensaje) {
        this.show({tipo: "info",  titulo: "Información", mensaje: mensaje});
    }
    showExito(mensaje) {
        this.show({tipo: "success",  titulo: "Éxito", mensaje: mensaje});
    }

    close() {
        this.subscribers.forEach((fn) => fn(null));
    }
}

export default new AvisoModalServicio();